import { Text } from "@chakra-ui/react"
import React from "react"
import { Address } from "~/interfaces/entities/Address"
import AdressCountry from "./AddressCountry"
import { getAddressLines } from "./addressFormatter"

interface Props {
  address: Address
}

const AddressJP: React.FC<Props> = ({ address }) => {
  const addressLine = getAddressLines(address)
  const { postcode, city, name, country } = address

  //The following applies if the address is written in japanese
  //Note that city and state is written in the address line already
  return (
    <>
      {/* Japanese postcode symbol is 〒*/}
      {postcode && <Text>〒{postcode}</Text>}
      <Text>{addressLine}</Text>
      <Text>{city}</Text>
      {!!name && <Text>{name}</Text>}
      <AdressCountry code={country} />
    </>
  )
}

export default AddressJP
